const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);

export const clamp01 = (value: number) => clamp(value, 0, 1);

export function winIntensityFromMultiplier(multiplier: number, maxMultiplier: number): number {
	const safeMultiplier = Number.isFinite(multiplier) ? multiplier : 1;
	const safeMax = Number.isFinite(maxMultiplier) ? maxMultiplier : 1;
	const m = Math.max(1, safeMultiplier);
	const max = Math.max(1, safeMax);
	if (max === 1) return 0;
	return clamp01(Math.log(m) / Math.log(max));
}

